<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" visibleDepartment visibleComName visibleRank :visible-field-form="visibleFieldForm || false" />

    <!-- 점검정보 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 업무 수행 여부</h5>
    </div>

    <!-- 업무 수행 여부 -->
    <div class="table-container">
      <table class="table">
        <colgroup>
          <col width="72" />
          <col width="80" />
          <col width="80" />
          <col />
          <col width="80" />
          <col width="80" />
          <col width="80" />
          <col width="80" />
          <col width="80" />
          <col width="400" />
        </colgroup>
        <thead>
          <tr>
            <th rowspan="2" colspan="4">항목</th>
            <th rowspan="2" class="point-column">배점</th>
            <th colspan="4" class="point-column">사업장</th>
            <th rowspan="2" class="note-column">비고</th>
          </tr>
          <tr>
            <th class="point-column">인천</th>
            <th class="point-column">당진</th>
            <th class="point-column">포항</th>
            <th class="point-column">연구소</th>
          </tr>
        </thead>
        <tbody>
          <!-- 시스템 지수 -->
          <tr>
            <td class="category-title">시스템<br />지수</td>
            <td colspan="3">Audit Check List 평가</td>
            <td class="number-data">45</td>
            <td><number-input align="center" show-controls :min="0" :max="45" v-model="form.업무수행.시스템지수.AuditCheckList.인천" /></td>
            <td><number-input align="center" show-controls :min="0" :max="45" v-model="form.업무수행.시스템지수.AuditCheckList.당진" /></td>
            <td><number-input align="center" show-controls :min="0" :max="45" v-model="form.업무수행.시스템지수.AuditCheckList.포항" /></td>
            <td><number-input align="center" show-controls :min="0" :max="45" v-model="form.업무수행.시스템지수.AuditCheckList.연구소" /></td>
            <td>
              <ml-input
                :readonly="readonly"
                visibleCounter
                :max="remarkMaxLength"
                :placeholder="remarkPlaceholder"
                @click.stop
                :title="form.업무수행.시스템지수.AuditCheckList.remark"
                v-model="form.업무수행.시스템지수.AuditCheckList.remark"
              />
            </td>
          </tr>

          <!-- 안전예방지수 -->
          <tr>
            <td rowspan="9" class="category-title">안전<br />예방<br />지수</td>
            <td rowspan="3">위험성<br />전과정<br />평가</td>
            <td rowspan="2">위험성<br />평가</td>
            <td>발굴율 (중요위험 건 / 실시 건)</td>
            <td class="number-data">5</td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.위험성평가.발굴율.인천" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.위험성평가.발굴율.당진" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.위험성평가.발굴율.포항" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.위험성평가.발굴율.연구소" /></td>
            <td>
              <ml-input
                :readonly="readonly"
                visibleCounter
                :max="remarkMaxLength"
                :placeholder="remarkPlaceholder"
                @click.stop
                :title="form.업무수행.안전예방지수.위험성평가.발굴율.remark"
                v-model="form.업무수행.안전예방지수.위험성평가.발굴율.remark"
              />
            </td>
          </tr>
          <tr>
            <td>개선율 (개선완료 / 중요위험 건)</td>
            <td class="number-data">5</td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.위험성평가.개선율.인천" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.위험성평가.개선율.당진" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.위험성평가.개선율.포항" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.위험성평가.개선율.연구소" /></td>
            <td>
              <ml-input
                :readonly="readonly"
                visibleCounter
                :max="remarkMaxLength"
                :placeholder="remarkPlaceholder"
                @click.stop
                :title="form.업무수행.안전예방지수.위험성평가.개선율.remark"
                v-model="form.업무수행.안전예방지수.위험성평가.개선율.remark"
              />
            </td>
          </tr>
          <tr>
            <td colspan="2">안전검증</td>
            <td class="number-data">5</td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.위험성평가.안전검증.인천" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.위험성평가.안전검증.당진" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.위험성평가.안전검증.포항" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.위험성평가.안전검증.연구소" /></td>
            <td>
              <ml-input
                :readonly="readonly"
                visibleCounter
                :max="remarkMaxLength"
                :placeholder="remarkPlaceholder"
                @click.stop
                :title="form.업무수행.안전예방지수.위험성평가.안전검증.remark"
                v-model="form.업무수행.안전예방지수.위험성평가.안전검증.remark"
              />
            </td>
          </tr>
          <tr class="sum-row">
            <td colspan="3" class="number-data"></td>
            <td class="number-data">15</td>
            <td class="number-data">{{ 위험성평가소계("인천") }}</td>
            <td class="number-data">{{ 위험성평가소계("당진") }}</td>
            <td class="number-data">{{ 위험성평가소계("포항") }}</td>
            <td class="number-data">{{ 위험성평가소계("연구소") }}</td>
            <td></td>
          </tr>

          <!-- 안전점검 -->
          <tr>
            <td rowspan="2">특성화<br />활동</td>
            <td colspan="2">안전중점</td>
            <td class="number-data">5</td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.특성화활동.안전중점.인천" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.특성화활동.안전중점.당진" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.특성화활동.안전중점.포항" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.특성화활동.안전중점.연구소" /></td>
            <td>
              <ml-input
                :readonly="readonly"
                visibleCounter
                :max="remarkMaxLength"
                :placeholder="remarkPlaceholder"
                @click.stop
                :title="form.업무수행.안전예방지수.특성화활동.안전중점.remark"
                v-model="form.업무수행.안전예방지수.특성화활동.안전중점.remark"
              />
            </td>
          </tr>

          <tr>
            <td colspan="2">D-SaFe 활용</td>
            <td class="number-data">5</td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.특성화활동.DSafe.인천" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.특성화활동.DSafe.당진" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.특성화활동.DSafe.포항" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.특성화활동.DSafe.연구소" /></td>
            <td>
              <ml-input
                :readonly="readonly"
                visibleCounter
                :max="remarkMaxLength"
                :placeholder="remarkPlaceholder"
                @click.stop
                :title="form.업무수행.안전예방지수.특성화활동.DSafe.remark"
                v-model="form.업무수행.안전예방지수.특성화활동.DSafe.remark"
              />
            </td>
          </tr>
          <tr class="sum-row">
            <td colspan="3" class="number-data"></td>
            <td class="number-data">10</td>
            <td class="number-data" :class="특성화활동소계('인천') > 10 ? ['text-red'] : []">{{ 특성화활동소계("인천") }}</td>
            <td class="number-data" :class="특성화활동소계('당진') > 10 ? ['text-red'] : []">{{ 특성화활동소계("당진") }}</td>
            <td class="number-data" :class="특성화활동소계('포항') > 10 ? ['text-red'] : []">{{ 특성화활동소계("포항") }}</td>
            <td class="number-data" :class="특성화활동소계('연구소') > 10 ? ['text-red'] : []">{{ 특성화활동소계("연구소") }}</td>
            <td></td>
          </tr>

          <!-- 비상훈련 -->
          <tr>
            <td>비상훈련</td>
            <td colspan="2">참여율</td>
            <td class="number-data">5</td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.비상훈련.참여율.인천" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.비상훈련.참여율.당진" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.비상훈련.참여율.포항" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.안전예방지수.비상훈련.참여율.연구소" /></td>
            <td>
              <ml-input
                :readonly="readonly"
                visibleCounter
                :max="remarkMaxLength"
                :placeholder="remarkPlaceholder"
                @click.stop
                :title="form.업무수행.안전예방지수.비상훈련.참여율.remark"
                v-model="form.업무수행.안전예방지수.비상훈련.참여율.remark"
              />
            </td>
          </tr>

          <!-- 안전 예방 지수 전체 소계 -->
          <tr class="sum-row">
            <td colspan="3" class="category-title">소계</td>
            <td class="category-title number-data">30</td>
            <td class="category-title number-data" :class="안전예방지수소계('인천') > 30 ? ['text-red'] : []">{{ 안전예방지수소계("인천") }}</td>
            <td class="category-title number-data" :class="안전예방지수소계('당진') > 30 ? ['text-red'] : []">{{ 안전예방지수소계("당진") }}</td>
            <td class="category-title number-data" :class="안전예방지수소계('포항') > 30 ? ['text-red'] : []">{{ 안전예방지수소계("포항") }}</td>
            <td class="category-title number-data" :class="안전예방지수소계('연구소') > 30 ? ['text-red'] : []">{{ 안전예방지수소계("연구소") }}</td>
            <td class="category-title"></td>
          </tr>

          <!-- 재해지수 -->
          <tr>
            <td rowspan="3" class="category-title">재해<br />지수</td>
            <td>직영</td>
            <td colspan="2">재해율 증감</td>
            <td class="number-data">20</td>
            <td><number-input align="center" show-controls :min="0" :max="20" v-model="form.업무수행.재해지수.직영.인천" /></td>
            <td><number-input align="center" show-controls :min="0" :max="20" v-model="form.업무수행.재해지수.직영.당진" /></td>
            <td><number-input align="center" show-controls :min="0" :max="20" v-model="form.업무수행.재해지수.직영.포항" /></td>
            <td><number-input align="center" show-controls :min="0" :max="20" v-model="form.업무수행.재해지수.직영.연구소" /></td>
            <td><ml-input :readonly="readonly" visibleCounter :max="remarkMaxLength" :placeholder="remarkPlaceholder" @click.stop :title="form.업무수행.재해지수.직영.remark" v-model="form.업무수행.재해지수.직영.remark" /></td>
          </tr>
          <tr>
            <td>수급</td>
            <td colspan="2">산업재해 발생 건 (건당 감점부여)</td>
            <td class="number-data">5</td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.재해지수.수급사.인천" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.재해지수.수급사.당진" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.재해지수.수급사.포항" /></td>
            <td><number-input align="center" show-controls :min="0" :max="5" v-model="form.업무수행.재해지수.수급사.연구소" /></td>
            <td><ml-input :readonly="readonly" visibleCounter :max="remarkMaxLength" :placeholder="remarkPlaceholder" @click.stop :title="form.업무수행.재해지수.수급사.remark" v-model="form.업무수행.재해지수.수급사.remark" /></td>
          </tr>
          <tr class="sum-row">
            <td colspan="3" class="number-data category-title">소계</td>
            <td class="number-data category-title">25</td>
            <td class="number-data category-title">{{ numberFormat(재해지수소계("인천")) }}</td>
            <td class="number-data category-title">{{ numberFormat(재해지수소계("당진")) }}</td>
            <td class="number-data category-title">{{ numberFormat(재해지수소계("포항")) }}</td>
            <td class="number-data category-title">{{ numberFormat(재해지수소계("연구소")) }}</td>
            <td class="category-title"></td>
          </tr>

          <!-- 합계 -->
          <tr class="sum-sum-row">
            <td colspan="4" class="number-data">합계</td>
            <td class="number-data">100</td>
            <td class="number-data">{{ numberFormat(전체합계("인천")) }}</td>
            <td class="number-data">{{ numberFormat(전체합계("당진")) }}</td>
            <td class="number-data">{{ numberFormat(전체합계("포항")) }}</td>
            <td class="number-data">{{ numberFormat(전체합계("연구소")) }}</td>
            <td class="number-data"></td>
          </tr>

          <!-- 가감점 -->
          <tr class="sum-sum-row">
            <td colspan="4" class="number-data">가감점</td>
            <td class="number-data"></td>
            <td><number-input align="center" show-controls :min="-100" :max="100" v-model="form.업무수행.가감점.인천" /></td>
            <td><number-input align="center" show-controls :min="-100" :max="100" v-model="form.업무수행.가감점.당진" /></td>
            <td><number-input align="center" show-controls :min="-100" :max="100" v-model="form.업무수행.가감점.포항" /></td>
            <td><number-input align="center" show-controls :min="-100" :max="100" v-model="form.업무수행.가감점.연구소" /></td>
            <td><ml-input :readonly="readonly" visibleCounter :max="remarkMaxLength" :placeholder="remarkPlaceholder" @click.stop :title="form.업무수행.가감점.remark" v-model="form.업무수행.가감점.remark" /></td>
          </tr>

          <!-- 최종 점수 -->
          <tr class="final-sum-row">
            <td colspan="4" class="number-data">최종 점수</td>
            <td class="number-data"></td>
            <td class="number-data">{{ numberFormat(최종점수("인천")) }}</td>
            <td class="number-data">{{ numberFormat(최종점수("당진")) }}</td>
            <td class="number-data">{{ numberFormat(최종점수("포항")) }}</td>
            <td class="number-data">{{ numberFormat(최종점수("연구소")) }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import NumberInput from "@/components/NumberInput.vue";

const TARGETS = ["인천", "당진", "포항", "연구소"];
const 위험성평가키 = ["발굴율", "개선율", "안전검증"];
const 특성화활동키 = ["안전중점", "DSafe"];
const 재해지수키 = ["직영", "수급사"];

export default {
  components: {
    NumberInput,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      pointPlaceholder: "숫자입력",
      remarkPlaceholder: "비고",
      remarkMaxLength: 200,
      form: {
        stdInfo: {},
        fileList: [],
        업무수행: {
          point: 100,
          // 시스템 지수
          시스템지수: {
            point: 45,
            AuditCheckList: {
              point: 45,
              인천: 0,
              당진: 0,
              포항: 0,
              연구소: 0,
              remark: "상, 하반기 안전보건 Audit 결과 반영(중처법 1,000점, 산안법 1,000점)",
              file: {},
            },
          },
          // 안전 예방 지수
          안전예방지수: {
            point: 30,
            // 위험성 평가
            위험성평가: {
              point: 15,
              발굴율: { point: 5, 인천: 0, 당진: 0, 포항: 0, 연구소: 0, remark: "", file: {} },
              개선율: { point: 5, 인천: 0, 당진: 0, 포항: 0, 연구소: 0, remark: "", file: {} },
              안전검증: { point: 5, 인천: 0, 당진: 0, 포항: 0, 연구소: 0, remark: "", file: {} },
            },
            // 특성화 활동 (템플릿 기준)
            특성화활동: {
              point: 10,
              안전중점: { point: 5, 인천: 0, 당진: 0, 포항: 0, 연구소: 0, remark: "", file: {} },
              DSafe: { point: 5, 인천: 0, 당진: 0, 포항: 0, 연구소: 0, remark: "", file: {} },
            },
            // 비상훈련
            비상훈련: {
              point: 5,
              참여율: { point: 5, 인천: 0, 당진: 0, 포항: 0, 연구소: 0, remark: "", file: {} },
            },
          },
          // 재해 지수
          재해지수: {
            point: 25,
            직영: { point: 20, 인천: 0, 당진: 0, 포항: 0, 연구소: 0, remark: "", file: {} },
            수급사: { point: 5, 인천: 0, 당진: 0, 포항: 0, 연구소: 0, remark: "", file: {} },
          },
          // 가감점 / 최종점수
          가감점: { point: 100, 인천: 0, 당진: 0, 포항: 0, 연구소: 0, remark: "" },
          최종점수: { point: 100, 인천: 0, 당진: 0, 포항: 0, 연구소: 0 },
        },
      },
    };
  },
  computed: {
    readonly() {
      return this.board.readonly || this.isPrint;
    },
    visibleFieldForm() {
      return this.$store.state.board.boardData.only_related_field;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value && value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        for (const target of TARGETS) {
          // 시스템 지수
          if (this.form.업무수행.시스템지수.AuditCheckList[target] === "") {
            this.form.업무수행.시스템지수.AuditCheckList[target] = 0;
          }

          // 위험성 평가
          for (const key of 위험성평가키) {
            if (this.form.업무수행.안전예방지수.위험성평가[key][target] === "") {
              this.form.업무수행.안전예방지수.위험성평가[key][target] = 0;
            }
          }

          // 특성화 활동
          for (const key of 특성화활동키) {
            if (this.form.업무수행.안전예방지수.특성화활동[key][target] === "") {
              this.form.업무수행.안전예방지수.특성화활동[key][target] = 0;
            }
          }

          // 비상훈련
          if (this.form.업무수행.안전예방지수.비상훈련.참여율[target] === "") {
            this.form.업무수행.안전예방지수.비상훈련.참여율[target] = 0;
          }

          // 재해지수
          for (const key of 재해지수키) {
            if (this.form.업무수행.재해지수[key][target] === "") {
              this.form.업무수행.재해지수[key][target] = 0;
            }
          }

          // 가감점
          if (this.form.업무수행.가감점[target] === "") {
            this.form.업무수행.가감점[target] = 0;
          }

          // 최종점수 갱신
          this.form.업무수행.최종점수[target] = this.최종점수(target);
        }

        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value && this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    /**
     * @param target 인천, 당진, 포항, 연구소
     * @returns {number}
     */
    위험성평가소계(target) {
      const form = this.form.업무수행.안전예방지수.위험성평가;
      const sum = (form.발굴율[target] || 0) + (form.개선율[target] || 0) + (form.안전검증[target] || 0);
      return parseFloat(sum.toFixed(1));
    },
    // 템플릿의 "특성화활동소계" → 특성화활동 합산
    특성화활동소계(target) {
      const form = this.form.업무수행.안전예방지수.특성화활동;
      const sum = (form.안전중점[target] || 0) + (form.DSafe[target] || 0);
      return parseFloat(sum.toFixed(1));
    },
    안전예방지수소계(target) {
      const 위험성평가 = this.위험성평가소계(target);
      const 특성화활동 = this.특성화활동소계(target); // 현재 특성화활동 합을 여기서 계산 중
      const 비상훈련 = this.form.업무수행.안전예방지수.비상훈련.참여율[target] || 0;

      const sum = 위험성평가 + 특성화활동 + 비상훈련;
      return parseFloat(sum.toFixed(1));
    },
    재해지수소계(target) {
      const form = this.form.업무수행.재해지수;
      const sum = (form.직영[target] || 0) + (form.수급사[target] || 0);
      return parseFloat(sum.toFixed(1));
    },
    전체합계(target) {
      const auditCheckList = this.form.업무수행.시스템지수.AuditCheckList[target] || 0;
      const 위험성평가 = this.위험성평가소계(target);
      const 안전검증 = this.특성화활동소계(target); // = 특성화활동 소계
      const 비상훈련 = this.form.업무수행.안전예방지수.비상훈련.참여율[target] || 0;
      const 재해지수 = this.재해지수소계(target);

      const sum = auditCheckList + 위험성평가 + 안전검증 + 비상훈련 + 재해지수;
      return parseFloat(sum.toFixed(1));
    },
    최종점수(target) {
      const sum = this.전체합계(target) + (this.form.업무수행.가감점[target] || 0);
      return parseFloat(sum.toFixed(1));
    },
    numberFormat(value) {
      if (value === null || value === undefined) return "";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style lang="scss" scoped>
.table-container {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;

  tr {
    background-color: #ffffff;
    &.sum-row {
      background-color: #f9f9f9;
    }
    &.sum-sum-row {
      background-color: #fffbf2;
    }
    &.final-sum-row {
      background-color: #ffe9af;
    }
  }

  td {
    text-align: center;
    word-break: keep-all;
    border: 1px solid #cdcdcd;
    padding: 4px;

    &.category-title {
      font-size: 14px;
      font-weight: 700;
      color: #3c3c3c;
      background-color: #efefef;
      text-align: center;
    }

    &.number-data {
      font-size: 14px;
      color: #3c3c3c;
      font-weight: 500;
      text-align: center;
      padding: 8px 4px;
    }
    .point-input {
      max-width: 86px;
    }
    .file-input {
      max-width: 160px;
    }
  }
  th {
    background-color: #efefef;
    padding: 6px 0;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    border: 1px solid #cdcdcd;
  }
}

input[type="text"] {
  width: 100%;
  padding: 4px;
  box-sizing: border-box;
}
button {
  padding: 4px 8px;
}
</style>
